import React from "react";
import "../../css/table.css";
import ReactTable from "react-table";
import { connect } from "react-redux";
import GoalForm from "../../forms/GoalForm.jsx";
import Card from "../../components/Card/Card.jsx";
import { db } from "../../services/firebase";
import Modal from "../../components/Modal/Modal.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationSystem from "react-notification-system";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faTrophy } from "@fortawesome/fontawesome-free-solid";
import SweetSpinner from "../../components/SweetSpinner/SweetSpinner.jsx";
import { style as NotifyStyle } from "../../variables/Variables.jsx";
import { Grid, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";

class Goals extends React.Component {
  state = {
    goals: [],
    fetching: true,
    targetIndicator: null,
    goalModal: false,
    alert: null,
    _notificationSystem: null,
  };

  componentDidMount() {
    this._fetch();
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  render() {
    const { goals, fetching } = this.state;
    return (
      <div className="main-content">
        {this.state.alert}
        {this.goalModal()}
        <NotificationSystem ref="notificationSystem" style={NotifyStyle} />
        <Grid fluid>
          <Card
            content={
              <Row>
                <Col md={12}>
                  <ReactTable
                    columns={[
                      { Header: "Produto", accessor: "productName" },
                      { Header: "Indicador", accessor: "name" },
                      { Header: "Meta (gramas)", accessor: "goal" },
                      {
                        Header: "Ações",
                        accessor: "",
                        Cell: ({ value }) => (
                          <div style={{ textAlign: "center" }}>
                            {this.props.user.roleName === "PCP" && (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id={`edit_${value.id}`}>
                                    Alterar Meta
                                  </Tooltip>
                                }
                              >
                                <a
                                  className="btn btn-simple btn-default btn-icon"
                                  onClick={() =>
                                    this.setState({
                                      targetIndicator: value,
                                      goalModal: true,
                                    })
                                  }
                                >
                                  <FontAwesomeIcon
                                    className="text-dark"
                                    icon={faTrophy}
                                  />
                                </a>
                              </OverlayTrigger>
                            )}
                            {this.props.user.roleName !== "PCP" && "-"}
                          </div>
                        ),
                      },
                    ]}
                    data={goals}
                    loading={fetching}
                    defaultPageSize={10}
                    className="-striped -highlight"
                    previousText="Anterior"
                    nextText="Próximo"
                    loadingText="Carregando"
                    noDataText="Nenhuma meta encontrada"
                    pageText="Página"
                    ofText="de"
                    rowsText="Registros"
                  />
                </Col>
              </Row>
            }
          />
        </Grid>
      </div>
    );
  }

  goalModal = () => {
    const { targetIndicator, goalModal } = this.state;
    if (targetIndicator) {
      return (
        <Modal
          title="Atualizar Meta"
          isOpen={goalModal}
          content={
            <GoalForm
              initialValues={targetIndicator}
              onSubmit={(values) => this._updateGoal(values)}
              handleCancel={() =>
                this.setState({ goalModal: false, targetIndicator: null })
              }
            />
          }
        />
      );
    }
  };

  _fetch = () => {
    const { company } = this.props.user;
    this.setState({ fetching: true });
    db.collection("companies")
      .doc(company)
      .collection("indicators")
      .onSnapshot((indicatorSnapshot) => {
        if (!indicatorSnapshot.empty) {
          const goals = [];
          indicatorSnapshot.forEach((indicator) => {
            db.collection("companies")
              .doc(company)
              .collection("products")
              .doc(indicator.data().product)
              .get()
              .then((product) => {
                goals.push({
                  ...indicator.data(),
                  id: indicator.id,
                  productName: product.data().name,
                  goal:
                    indicator.data().goal > 0
                      ? indicator.data().goal
                      : "Indefinida",
                  status: indicator.data().status,
                });
                this.setState({ goals });
              })
              .catch((e) => console.log(e));
          });
          this.setState({ fetching: false });
        } else {
          this.setState({ fetching: false });
        }
      });
  };

  _updateGoal = (values) => {
    const { company } = this.props.user;

    this.setState({ goalModal: false, targetIndicator: null });
    this.waitAlert("Atualizando meta", true);

    db.collection("companies")
      .doc(company)
      .collection("indicators")
      .doc(values.id)
      .update({ goal: values.goal })
      .then(() => {
        this.hideAlert();
        this.notify("Meta atualizada", "success");
      })
      .catch((e) => {
        this.hideAlert();
        this.notify("Erro ao atualizar meta", "error");
      });
  };

  //Notifications
  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: null,
      message: <b>{message}</b>,
      level,
      position: "tr",
      autoDismiss: 4,
    });
  };

  //SweetAlerts
  hideAlert = () => this.setState({ alert: null });

  waitAlert = (title, showSpinner) => {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block" }}
          title={title}
          onConfirm={() => null}
          showConfirm={false}
        >
          {showSpinner ? <SweetSpinner /> : null}
        </SweetAlert>
      ),
    });
  };
}

const mapStateToProps = (state) => ({ user: state.auth.user });

export default connect(mapStateToProps, null)(Goals);



// WEBPACK FOOTER //
// ./src/views/Goals/Goals.jsx